import * as actionTypes from '../actions/abflagsActionTypes';

const initialState: Record<string, boolean | string> = {};

type Action = {
    type: string;
    message?: string;
    payload: any;
    callback?: Function | undefined;
    error: any;
};

export const abflagsReducer = (state = initialState, action: Action) => {
    switch (action.type) {
        case actionTypes.UPDATE:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
